import { motion } from "framer-motion";
import { Search, Users, Ship, Package, Container } from "lucide-react";
import { useLang } from "../../i18n/LanguageContext";

const icons = [Search, Users, Ship, Package, Container];
const reds = [false, true, false, true, false];

export const ProofBar = () => {
  const { t } = useLang();
  return (
    <section data-testid="proof-bar" className="relative z-10 bg-white">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <motion.div
          initial={{ opacity: 0, y: 26 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
          className="-mt-24 md:-mt-28 rounded-3xl border border-black/[0.06] bg-white shadow-[0_20px_60px_rgba(11,18,32,0.10)] px-5 py-7 md:px-8 md:py-8"
        >
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-y-7 gap-x-4 lg:divide-x lg:divide-black/[0.06]">
            {t.proof.items.map((item, i) => {
              const Icon = icons[i];
              const red = reds[i];
              return (
                <div key={i} className="flex items-center gap-3.5 lg:px-5 first:lg:pl-0" data-testid={`proof-item-${i}`}>
                  <div className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-xl ${red ? "bg-sinovar-red" : "bg-sinovar-blue"}`}>
                    <Icon className="h-5 w-5 text-white" strokeWidth={1.8} />
                  </div>
                  <div>
                    <div className="font-display text-xl md:text-2xl font-bold tracking-tight text-sinovar-navy leading-none">
                      {item.value}
                    </div>
                    <div className="mt-1.5 text-[12px] font-medium text-sinovar-navy/55 leading-tight">
                      {item.label}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </motion.div>
      </div>
    </section>
  );
};
